import React from 'react';
import { motion } from 'framer-motion';
import { Shield, ArrowLeft } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { useNavigate } from 'react-router-dom';

const TermsOfService = () => {
    const navigate = useNavigate();

    return (
        <div className="min-h-screen bg-[#050505] text-gray-300 p-8 font-sans selection:bg-blue-500/30">
            <div className="max-w-4xl mx-auto">
                <Button
                    variant="ghost"
                    onClick={() => navigate('/')}
                    className="mb-8 hover:bg-white/5 text-gray-400 hover:text-white"
                >
                    <ArrowLeft className="mr-2 h-4 w-4" />
                    Voltar para o Login
                </Button>

                <motion.div
                    initial={{ opacity: 0, y: 20 }}
                    animate={{ opacity: 1, y: 0 }}
                    transition={{ duration: 0.5 }}
                    className="bg-black/40 backdrop-blur-xl border border-white/10 rounded-3xl p-8 md:p-12 shadow-2xl relative overflow-hidden"
                >
                    {/* Header */}
                    <div className="flex items-center gap-4 mb-10 border-b border-white/5 pb-8">
                        <div className="p-3 bg-blue-500/10 rounded-xl">
                            <Shield className="h-8 w-8 text-blue-500" />
                        </div>
                        <div>
                            <h1 className="text-3xl font-bold text-white mb-1">Termos de Serviço</h1>
                            <p className="text-gray-500">Última atualização: {new Date().toLocaleDateString()}</p>
                        </div>
                    </div>

                    {/* Content */}
                    <div className="space-y-8 text-lg leading-relaxed">
                        <section>
                            <h2 className="text-xl font-semibold text-white mb-3">1. Aceitação dos Termos</h2>
                            <p>
                                Ao acessar e usar o Sistema Capital, você concorda em cumprir e estar vinculado a estes Termos de Serviço.
                                Se você não concordar com qualquer parte destes termos, você não deve usar nosso serviço.
                            </p>
                        </section>

                        <section>
                            <h2 className="text-xl font-semibold text-white mb-3">2. Uso do Serviço</h2>
                            <p>
                                Você concorda em usar o serviço apenas para fins legais e de acordo com todas as leis aplicáveis.
                                O uso indevido, tentativas de invasão, ou qualquer atividade que comprometa a integridade do sistema
                                resultará no banimento imediato e permanente.
                            </p>
                        </section>

                        <section>
                            <h2 className="text-xl font-semibold text-white mb-3">3. Contas e Segurança</h2>
                            <p>
                                Você é responsável por manter a confidencialidade de sua conta do Discord e por todas as atividades
                                que ocorrem sob sua conta. Notifique-nos imediatamente sobre qualquer uso não autorizado.
                            </p>
                        </section>

                        <section>
                            <h2 className="text-xl font-semibold text-white mb-3">4. Regras de Conduta</h2>
                            <ul className="list-disc pl-6 space-y-2 mt-2 text-gray-400">
                                <li>Não utilize linguagem ofensiva ou discriminatória.</li>
                                <li>Respeite os membros da equipe e outros usuários.</li>
                                <li>Não faça spam ou sobrecarregue o sistema de tickets intencionalmente.</li>
                                <li>Forneça informações verdadeiras e precisas.</li>
                            </ul>
                        </section>

                        <section>
                            <h2 className="text-xl font-semibold text-white mb-3">5. Modificações</h2>
                            <p>
                                Reservamo-nos o direito de modificar estes termos a qualquer momento. As alterações entram em vigor
                                imediatamente após a publicação. Seu uso continuado do serviço constitui aceitação dos novos termos.
                            </p>
                        </section>

                        <section>
                            <h2 className="text-xl font-semibold text-white mb-3">6. Contato</h2>
                            <p>
                                Se você tiver dúvidas sobre estes Termos, entre em contato com nossa equipe de suporte através do sistema de tickets.
                            </p>
                        </section>
                    </div>

                    <div className="mt-12 pt-8 border-t border-white/5 text-center text-sm text-gray-500">
                        &copy; {new Date().getFullYear()} Grupo Capital. Todos os direitos reservados.
                    </div>
                </motion.div>
            </div>
        </div>
    );
};

export default TermsOfService;
